import { render, staticRenderFns } from "./LinkedDocument.vue?vue&type=template&id=0af70c7f&"
import script from "./LinkedDocument.vue?vue&type=script&lang=js&"
export * from "./LinkedDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports